<template>
  <RevContainer>
    <div class="bg-surface-default-low py-32">
      <div class="mx-auto">
        <h2 class="heading-3 mb-24">
          {{ i18n(translations.mainTitle) }}
        </h2>
        <RevTabs
          v-if="sections.length > 1"
          class="mb-32"
          :label="i18n(translations.tabsLabel)"
          variant="flexible"
        >
          <RevTabItem
            v-for="(section, index) in sections"
            :key="index"
            :active="activeTabIndex === index"
            :label="section.title"
            @click="activeTabIndex = index"
          />
        </RevTabs>
        <h2 class="heading-3 mb-24">{{ sections[activeTabIndex].title }}</h2>
        <div class="mt-24">
          <SeoFooterLinks
            :key="activeTabIndex"
            :links="sections[activeTabIndex].links"
            :max-visible-links="39"
            :see-more-label="i18n(translations.seeMore)"
            @link-click="emit('link-click', $event)"
          />
        </div>
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import type { SeoSection } from './SeoFooterLinks.types'
import SeoFooterLinks from './SeoFooterLinks.vue'
import translations from './SeoFooterLinksContainer.translations'

const i18n = useI18n()

const emit = defineEmits<{
  (e: 'link-click', product: { label: string; position: number }): void
}>()

defineProps<{
  sections: SeoSection[]
}>()

const activeTabIndex = ref(0)
</script>
